/**
 * TRENDVILA — Handcrafted Boutique Theme Interactions Script
 * Built with Vanilla JavaScript ES6 for maximum performance, 0 dependencies.
 */

document.addEventListener('DOMContentLoaded', () => {
  initHeaderScroll();
  initWishlist();
  initProductGallery();
  initMobileMenu();
  initScrollAnimations();
  initCartDrawer();
  initAjaxCart();
  initQuickView();
  initAccordions();
  initIngredientCards();
  initParallaxEffects();
  initSearchPopup();
});

function initHeaderScroll() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const handleScroll = () => {
    if (window.scrollY > 40) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  };
  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
}

function initMobileMenu() {
  const menu = document.getElementById('MobileNav');
  const toggle = document.querySelector('[data-action="open-mobile-nav"]');
  const backdrop = document.querySelector('.mobile-nav-backdrop');
  if (!menu || !toggle || !backdrop) return;
  const open = () => {
    menu.classList.add('is-open'); backdrop.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false'); toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };
  const close = () => {
    menu.classList.remove('is-open'); backdrop.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true'); toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };
  toggle.addEventListener('click', open);
  document.querySelectorAll('[data-action="close-mobile-nav"]').forEach((button) => button.addEventListener('click', close));
  menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
}

function initProductGallery() {
  const main = document.getElementById('mainProductImage');
  const thumbs = [...document.querySelectorAll('[data-product-thumb]')];
  if (!main || !thumbs.length) return;
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
    main.src = thumb.dataset.fullImage || thumb.src;
    thumbs.forEach((item) => item.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }));
  if (thumbs[0]) thumbs[0].classList.add('is-active');
}

function initWishlist() {
  const storageKey = 'trendvila-wishlist';
  let saved = [];
  try { saved = JSON.parse(localStorage.getItem(storageKey) || localStorage.getItem('potent-potions-wishlist') || '[]'); } catch (error) { saved = []; }
  const humanize = (value) => value.replace(/^trendvila-/, '').replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
  saved = saved.map((item) => typeof item === 'string' ? { key: item, title: humanize(item), url: `/products/${item}` } : item);

  const cardData = {};
  document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
    cardData[button.dataset.productKey] = {
      key: button.dataset.productKey,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      variantId: button.dataset.variantId
    };
  });
  saved = saved.map((item) => ({ ...item, ...(cardData[item.key] || {}) }));

  const drawer = document.createElement('aside');
  drawer.className = 'wishlist-drawer';
  drawer.setAttribute('aria-label', 'Wishlist');
  drawer.innerHTML = '<div class="wishlist-drawer__header"><div><small>YOUR FAVORITES</small><h2>My Wishlist</h2></div><button class="wishlist-drawer__close" aria-label="Close wishlist">&times;</button></div><div class="wishlist-drawer__items"></div><div class="wishlist-drawer__footer"><a href="/collections/all" class="btn-primary"><span>Continue Shopping</span></a></div>';
  const backdrop = document.createElement('button');
  backdrop.className = 'wishlist-backdrop';
  backdrop.setAttribute('aria-label', 'Close wishlist');
  document.body.append(backdrop, drawer);
  const persist = () => {
    try { localStorage.setItem(storageKey, JSON.stringify(saved)); } catch (error) {}
  };
  const updateCount = () => document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
    count.textContent = saved.length;
    count.hidden = saved.length === 0;
  });
  const renderDrawer = () => {
    const list = drawer.querySelector('.wishlist-drawer__items');
    list.innerHTML = saved.length ? saved.map((item) => `<article class="wishlist-item">${item.image ? `<a href="${item.url || '#'}" class="wishlist-item__image"><img src="${item.image}" alt=""></a>` : ''}<div class="wishlist-item__details"><small>HANDCRAFTED CREATION</small><a href="${item.url || '#'}" class="wishlist-item__title">${item.title || humanize(item.key)}</a>${item.price ? `<strong>${item.price}</strong>` : ''}<div class="wishlist-item__actions">${item.variantId ? `<button type="button" data-wishlist-add="${item.variantId}">Add to cart</button>` : ''}<button type="button" data-wishlist-remove="${item.key}">Remove</button></div></div></article>`).join('') : '<div class="wishlist-empty"><span>♡</span><h3>Your Wishlist is Empty</h3><p>Save charms & creations you would like to revisit.</p></div>';
    updateCount();
  };
  renderDrawer();

  document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
    const key = button.dataset.productKey;
    const render = () => {
      const active = saved.some((item) => item.key === key);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    };
    render();
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const existing = saved.findIndex((item) => item.key === key);
      if (existing >= 0) {
        saved.splice(existing, 1);
      } else {
        saved.unshift({
          key,
          title: button.dataset.productTitle || humanize(key),
          url: button.dataset.productUrl || `/products/${key}`,
          image: button.dataset.productImage || '',
          price: button.dataset.productPrice || '',
          variantId: button.dataset.variantId || ''
        });
      }
      persist();
      render();
      renderDrawer();
    });
  });

  const openDrawer = (event) => {
    if (event) event.preventDefault();
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  };
  document.querySelectorAll('[data-action="open-wishlist"]').forEach((btn) => btn.addEventListener('click', openDrawer));
  drawer.querySelector('.wishlist-drawer__close').addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);
}

function initScrollAnimations() {
  const elements = document.querySelectorAll('.reveal-on-scroll');
  if (!elements.length) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
      }
    });
  }, { threshold: 0.15 });
  elements.forEach((el) => observer.observe(el));
}

function initCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('DrawerOverlay');
  if (!drawer || !overlay) return;

  const openDrawer = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  };
  const closeDrawer = () => {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-action="open-cart"]')) openDrawer(e);
    if (e.target.closest('[data-action="close-cart"]')) closeDrawer();
  });
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  window.Trendvila = window.Trendvila || {};
  window.PotentPotions = window.Trendvila;
  window.Trendvila.openCart = openDrawer;
  window.Trendvila.closeCart = closeDrawer;
}

function initAjaxCart() {
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span>Adding...</span>';
    }

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      if (res.ok) {
        // Update cart drawer
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        document.querySelectorAll('.cart-count').forEach((el) => el.textContent = cartData.item_count);
        window.location.reload();
      }
    } catch (err) {
      console.error(err);
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    }
  });
}

function initQuickView() {
  const modal = document.getElementById('QuickViewModal');
  const overlay = document.getElementById('DrawerOverlay');
  if (!modal) return;

  const closeQv = () => {
    modal.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  document.addEventListener('click', (e) => {
    const qvBtn = e.target.closest('[data-action="quick-view"]');
    if (qvBtn) {
      e.preventDefault();
      const title = qvBtn.dataset.productTitle || '';
      const subtitle = qvBtn.dataset.productSubtitle || '';
      const price = qvBtn.dataset.productPrice || '';
      const image = qvBtn.dataset.productImage || '';
      const url = qvBtn.dataset.productUrl || '#';
      const ingredients = qvBtn.dataset.ingredients || '';

      if (modal.querySelector('.qv-title')) modal.querySelector('.qv-title').textContent = title;
      if (modal.querySelector('.qv-sub')) modal.querySelector('.qv-sub').textContent = subtitle;
      if (modal.querySelector('.qv-price')) modal.querySelector('.qv-price').textContent = price;
      if (modal.querySelector('.qv-image')) modal.querySelector('.qv-image').src = image;
      if (modal.querySelector('#QuickViewLink')) modal.querySelector('#QuickViewLink').href = url;
      if (modal.querySelector('.qv-ingredients')) modal.querySelector('.qv-ingredients').textContent = ingredients;

      modal.classList.add('active');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
    if (e.target.closest('[data-action="close-qv"]')) closeQv();
  });
}

function initAccordions() {
  document.querySelectorAll('.accordion-header').forEach((header) => {
    header.addEventListener('click', () => {
      const item = header.parentElement;
      const content = header.nextElementSibling;
      const isOpen = item.classList.contains('open');
      if (isOpen) {
        item.classList.remove('open');
        content.style.maxHeight = '0px';
      } else {
        item.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
}

function initIngredientCards() {
  document.querySelectorAll('.ingredient-card').forEach((card) => {
    card.addEventListener('mouseenter', () => {
      card.style.transform = 'translateY(-6px)';
      card.style.boxShadow = 'var(--shadow-hover)';
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = 'none';
      card.style.boxShadow = 'none';
    });
  });
}

function initParallaxEffects() {}

function initSearchPopup() {
  const popup = document.getElementById('SearchPopup');
  if (!popup) return;
  const openSearch = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    popup.classList.add('active');
    document.body.style.overflow = 'hidden';
    const input = popup.querySelector('input');
    if (input) setTimeout(() => input.focus(), 200);
  };
  const closeSearch = () => {
    popup.classList.remove('active');
    document.body.style.overflow = '';
  };
  document.querySelectorAll('[data-action="open-search"]').forEach((btn) => btn.addEventListener('click', openSearch));
  document.querySelectorAll('[data-action="close-search"]').forEach((btn) => btn.addEventListener('click', closeSearch));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSearch(); });
}
